import { useQuery } from '@tanstack/react-query';
import { fetchProviderReferrals } from '../api/providerReferralsApi';
import { useAuth } from '@/features/authentication/hooks/useAuth';

/**
 * Hook to fetch existing referrals for a referred provider
 * Feature 001: SP Client Management - Provider Referrals
 *
 * @param referredProviderId - Referred Provider ID
 * @returns Query object with existing referrals
 */
export function useProviderReferrals(referredProviderId: string | null) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['sp', 'referrals', 'provider', referredProviderId],
    queryFn: () => {
      if (!referredProviderId || !user?.id) {
        return Promise.resolve([]);
      }
      return fetchProviderReferrals(user.id, referredProviderId);
    },
    enabled: !!referredProviderId && !!user?.id,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
